import { __assign } from "tslib";
import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { getCoverImageAttributes } from '../../Thumb/helpers';
import TextRenderer from '../../../TextRenderer';
import JournalViewer from '../../../DaEditorWrapper/Viewer/Journal';
import ReadingTime from '../../Feed/_partials/ByLine/ReadingTime';
import FeedCardLayout from '../_partials/FeedCardLayout';
import FeedCardTitle from '../_partials/FeedCardTitle';
import { DEFAULT_COVER_IMAGE_RESOLUTION_WIDTH, DEFAULT_COVER_IMAGE_RESOLUTION_HEIGHT, } from '../constants';
import draftTheme from '../../../DaEditorWrapper/Themes/Viewer/feedcard.scss';
import legacyTheme from '../../Feed/feedcard.legacy.theme.scss';
import s from './Journal.scss';
var COVER_DOM_HEIGHT = 180;
var JournalFeedCardContents = function (_a) {
    var className = _a.className, deviation = _a.deviation, extraActions = _a.extraActions;
    var coverImage = getCoverImageAttributes({
        deviation: deviation,
        width: DEFAULT_COVER_IMAGE_RESOLUTION_WIDTH,
        height: DEFAULT_COVER_IMAGE_RESOLUTION_HEIGHT,
        allowHuge: true,
    });
    // maintain this so we can track when we can enable scroll restoration on duperbrowse
    var _b = useState(false), isLayoutReady = _b[0], setIsLayoutReady = _b[1];
    var onLayoutReady = useCallback(function () {
        setIsLayoutReady(true);
    }, []);
    return (React.createElement(FeedCardLayout, { className: className, deviation: deviation, extraActions: extraActions, isExpandable: true, withCommentControl: true, withFaveControl: true, onLayoutReady: onLayoutReady },
        coverImage && (React.createElement("div", { className: s['cover-image'], style: __assign(__assign({}, coverImage.style), { height: COVER_DOM_HEIGHT }) },
            React.createElement("div", { className: s['fade'] }))),
        React.createElement(FeedCardTitle, { className: s['title'], deviation: deviation, disableScrollRestoration: !isLayoutReady }),
        React.createElement("div", { className: s['reading-time'] },
            React.createElement(ReadingTime, { deviation: deviation })),
        React.createElement(TextRenderer, { textContent: deviation.textContent, reactViewer: JournalViewer, viewerKey: deviation.deviationId, legacyTheme: "journal", fixedParagraph: false, draftjsThemeOverride: draftTheme, className: classnames(s['content'], legacyTheme['legacy'], legacyTheme['override'], draftTheme['override']) })));
};
JournalFeedCardContents.displayName = 'JournalFeedCardContents';
export default JournalFeedCardContents;
//# sourceMappingURL=Journal.js.map